import { toast, ToastOptions, ToastContent } from 'react-toastify';

const getToastTimeByChars = (text: string): number => {
  const time = (text.length / 13);
  return time < 5 ? 5000 : (time * 1000);
}

const getToastOptions = (content: ToastContent, options?: ToastOptions | undefined): ToastOptions | undefined => {
  if (typeof content === 'string' && (!options || typeof options.autoClose !== 'number')) {
    return {
      ...options,
      autoClose: getToastTimeByChars(content)
    }
  }
  return options;
}

export const getToastSuccess = (content: ToastContent, options?: ToastOptions | undefined): React.ReactText => {
  return toast.success(
    content,
    getToastOptions(content, options)
  );
}

export const getToastError = (content: ToastContent, options?: ToastOptions | undefined): React.ReactText => {
  return toast.error(
    content,
    getToastOptions(content, options)
  );
}